import api from './axios.js'

export const getPdfs = () => {
	return api.get('/content/documents/')
}
